// extracted by mini-css-extract-plugin
export default {"container":"layouts_container__f4PHs"};